exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js??ref--6-1!../../../../postcss-loader/src/index.js??ref--6-2!../global/variables.css"), "");
exports.i(require("-!../../node_modules/css-loader/index.js??ref--6-1!../../../../postcss-loader/src/index.js??ref--6-2!../global/global.css"), undefined);

// module
exports.push([module.id, ".title_1be {\n  font-weight: 600;\n}\n\n.error_495 {\n  margin-top: 4px;\n\n  word-wrap: break-word;\n\n  color: #ccc;\n\n  color: var(--ring-dark-active-color);\n\n  line-height: 16px;\n}\n", ""]);

// exports
exports.locals = {
	"unit": "" + require("-!../../node_modules/css-loader/index.js??ref--6-1!../../../../postcss-loader/src/index.js??ref--6-2!../global/global.css").locals["unit"] + "",
	"title": "title_1be",
	"error": "error_495"
};